import React, { Component } from "react"
import { Row, Col, Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap"
import RsLink from "components/buttons/rsLink";
class Footer extends Component {
  constructor(props) {
        super(props)
        this.state = {
            isPrivacy: false,
            isTerms: false,
        }
        this.togglePrivacyPolicy = this.togglePrivacyPolicy.bind(this);
        this.toggleTermsPolicy = this.toggleTermsPolicy.bind(this);
    }
    togglePrivacyPolicy() {
        this.setState(prevState => ({
            isPrivacy: !prevState.isPrivacy
        }));
    }
     toggleTermsPolicy() {
        this.setState(prevState => ({
            isTerms: !prevState.isTerms
        }));
    }
  render() {
    return (
      <React.Fragment>
        <footer className="footer">
          <div className="container-fluid">
            <Row>
              <Col sm={6}>{new Date().getFullYear()} © Realty Space.  <RsLink to="#" className="" iconClass="" onClick={this.togglePrivacyPolicy}>Privacy Policy</RsLink> {" "} <RsLink to="#" onClick={this.toggleTermsPolicy} className="" iconClass="">Term of Use</RsLink></Col>
              <Col sm={6}>
                <div className="text-sm-end d-none d-sm-block">
                  {/* Design & Develop by Esimplified */}
              </div>
              </Col>
            </Row>
          </div>
        </footer>
        <Offcanvas
                    isOpen={this.state.isPrivacy}
                    direction="end"
                    toggle={this.togglePrivacyPolicy}
                    style={{ width: 900 }}
                >
                    <OffcanvasHeader toggle={this.togglePrivacyPolicy}>
                        Privacy Policy
                    </OffcanvasHeader>
                    <OffcanvasBody>

                        <div className="text-content">

                            <p className="text-sm text-gray-600 mb-6">Effective Date: 13th July, 2026</p>
                            <p className="mb-6">
                                Company Name: <strong>1978778 Ontario Inc.,</strong> doing business as <strong>Realty Space</strong> (&quot;Company&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;)<br />
                                Website: <a
                                    href="https://www.realtyspace.co"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 underline"
                                >
                                    www.realtyspace.co
                                </a>
                            </p>

                            <div className="mb-8">
                                <p className="mb-4 font-bold">1. What Information We Collect</p>
                                <p className="mb-4">**a. Information You Provide**: We collect personal details like name, email, login, billing info, and uploaded data (e.g., client records, communication history).</p>
                                <p className="mb-4">**b. Information from Use of Our Services**: We collect IP address, browser/device data, activity logs, location, screen resolution, etc.</p>
                                <p className="mb-4">**c. Customer Data**: Clients may upload their own customer info. This data is owned by them and treated as confidential.</p>
                            </div>
                            <div className="mb-8">
                                <p className="mb-4 font-bold">2. How We Use Your Information</p>
                                <p className="mb-4">We use your information to deliver and improve Services, personalize experience, communicate, process billing, ensure security, and comply with legal obligations.</p>
                                <p className="mb-4">We do not sell your personal data.</p>
                            </div>
                            <div className="mb-8">
                                <p className="mb-4 font-bold">3. Sharing and Disclosure</p>
                                <p className="mb-4">We may share information with service providers, payment processors, legal authorities, or successors in business transfers. All third parties are bound by confidentiality obligations.</p>
                            </div>
                            <div className="mb-8">
                                <p className="mb-4 font-bold">4. Data Storage and Security</p>
                                <p className="mb-4">Data is stored on secure servers (Canada/US) using encryption and access controls. While we take reasonable precautions, no system is risk-free. Please keep your passwords secure.</p>
                            </div>
                            <div className="mb-8">
                                <p className="mb-4 font-bold">5. Cookies and Tracking Technologies</p>
                                <p className="mb-4">We use cookies to enhance experience, analyze usage, and support remarketing. You can manage cookie settings via your browser.</p>
                            </div>
                            <div className="mb-8">
                                <p className="mb-4 font-bold">6. Your Rights and Choices</p>
                                <p className="mb-4">You can access, update, withdraw consent, request deletion (where legal), or opt-out of marketing. Contact us at support@realtyspace.co. We respond within 30 days.</p>
                            </div>
                            <div className="mb-8">
                                <p className="mb-4 font-bold">7. Children’s Privacy</p>
                                <p className="mb-4">Our platform is not intended for users under 18. We do not knowingly collect data from minors.</p>
                            </div>
                            <div className="mb-8">
                                <p className="mb-4 font-bold">8. Cross-Border Data Transfers</p>
                                <p className="mb-4">By using our Services, you agree that your data may be stored/processed in jurisdictions outside your region, including the US.</p>
                            </div>
                            <div className="mb-8">
                              <p className="mb-4 font-bold">9. Google Workspace API Data Usage</p>
                              <p className="mb-4">Connecting a Google account to Realty Space is entirely optional and is required only for users who choose to use Gmail and Google Calendar integration features. Users who do not connect a Google account can continue using the core functionality of the application without these integrations.</p>
                              <p className="mb-4">When a user chooses to connect their Google account, Realty Space accesses only the Google Workspace data necessary to provide the requested functionality, such as synchronizing Gmail messages, sending emails from the user&apos;s Gmail account, and synchronizing Google Calendar events with CRM appointments.</p>
                              <p className="mb-4">Google Workspace data is accessed only with the user&apos;s explicit authorization and is used exclusively to provide the features requested by the user. Users may revoke Realty Space&apos;s access at any time through their Google Account settings or by disconnecting their Google account within the application.</p>
                              <p className="mb-4">Realty Space uses Microsoft Azure OpenAI Service to provide AI-assisted text generation features, such as drafting marketing content and email templates. Google Workspace data (including Gmail and Google Calendar data) is not transmitted to Azure OpenAI or any other AI service for processing, analysis, or AI model training.</p>
                              <p className="mb-4">The use and transfer of information received from Google Workspace APIs by Realty Space will adhere to the Google API Services User Data Policy, including the Limited Use requirements.</p>
                              <p className="mb-4">Realty Space does not use raw or aggregated/anonymized Google Workspace data for advertising, profiling, AI model training, or any purpose other than providing user-requested application functionality.</p>
                              <p className="mb-4">Realty Space does not sell Google Workspace data, use it for advertising purposes, or permit humans to read Google Workspace data except:</p>
                              <ul className="list-disc list-inside mb-4">
                                <li>when necessary to provide or troubleshoot a feature requested by the user,</li>
                                <li>when required to comply with applicable law, or</li>
                                <li>with the user&apos;s explicit consent.</li>
                              </ul>
                            </div>
                            <div className="mt-12">
                                <h2 className="text-xl font-semibold mb-2">Contact Us</h2>
                                <p>Privacy Officer</p>
                                <p>1978778 Ontario Inc. (Realty Space)</p>
                                <p>Email: <a href="mailto:support@realtyspace.co" className="text-blue-600 underline">support@realtyspace.co</a></p>
                                <p>Website: <a href="https://www.realtyspace.co" rel="noreferrer" target="_blank" className="text-blue-600 underline">www.realtyspace.co</a></p>
                            </div>
                        </div>



                    </OffcanvasBody>
                </Offcanvas>

                  <Offcanvas
                    isOpen={this.state.isTerms}
                    direction="end"
                    toggle={this.toggleTermsPolicy}
                    style={{ width: 900 }}
                >
                    <OffcanvasHeader toggle={this.toggleTermsPolicy}>
                       Terms of Use
                    </OffcanvasHeader>
                    <OffcanvasBody>
                        <div className="text-content">
     
      <p className="text-sm text-gray-600 mb-6">Effective Date: June 1, 2025</p>

      <p className="mb-6">
        Company Name: <strong>1978778 Ontario Inc.,</strong> doing business as{" "}
        <strong>Realty Space</strong> (&quot;Company&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;)
        <br />
        Website:{" "}
        <a
          href="https://www.realtyspace.co"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          www.realtyspace.co
        </a>
      </p>

      {/* Section 1 */}
      <div className="mb-8">
        <p className="mb-4 font-bold">1. Acceptance of Terms</p>
        <p className="mb-4">
          By accessing or using Realty Space (&quot;Platform&quot; or &quot;Service&quot;), you agree to be bound by
          these Terms of Use (&quot;Terms&quot;). If you are using the Service on behalf of an organization, you
          represent that you have the authority to bind that organization to these Terms. If you do not agree with
          any part of these Terms, you must not use the Service.
        </p>
      </div>

      {/* Section 2 */}
      <div className="mb-8">
        <p className="mb-4 font-bold">2. Description of Service</p>
        <p className="mb-4">
          Realty Space provides a web-based CRM platform tailored to real estate professionals for managing leads,
          communications, transactions, open houses, pre-construction projects, and other business activities.
        </p>
        <p className="mb-4">
          We reserve the right to modify, suspend, or discontinue the Service (or any part thereof) at any time,
          with or without notice.
        </p>
      </div>

      {/* Section 3 */}
      <div className="mb-8">
        <p className="mb-4 font-bold">3. User Eligibility</p>
        <p className="mb-4">
          You must be at least 18 years old and legally capable of entering into a binding agreement to use this
          Service. You agree to provide accurate, complete, and up-to-date information when creating an account.
        </p>
      </div>

      {/* Section 4 */}
      <div className="mb-8">
        <p className="mb-4 font-bold">4. Account Security</p>
        <p className="mb-4">
          You are responsible for maintaining the confidentiality of your login credentials and for all activities
          that occur under your account. Notify us immediately if you suspect any unauthorized use of your account.
        </p>
      </div>

      {/* Section 5 */}
      <div className="mb-8">
        <p className="mb-4 font-bold">5. Acceptable Use</p>
        <p className="mb-4">You agree not to:</p>
        <ul className="list-disc list-inside mb-4">
          <li>Use the Service for any unlawful or unauthorized purpose</li>
          <li>Interfere with or disrupt the Service or servers</li>
          <li>Attempt to gain unauthorized access to any portion of the Service</li>
          <li>Upload or transmit viruses or malicious code</li>
          <li>Use bots, scripts, or scraping tools without permission</li>
        </ul>
        <p className="mb-4">Misuse of the Service may result in account suspension or termination.</p>
      </div>

      {/* Section 6 */}
      <div className="mb-8">
        <p className="mb-4 font-bold">6. Customer Data</p>
        <p className="mb-4">
          You retain ownership of the data you input or upload into the platform (&quot;Customer Data&quot;). By
          using the Service, you grant us a limited license to use, store, and process Customer Data solely for the
          purpose of providing and improving the Service.
        </p>
        <p className="mb-4">
          You are solely responsible for the legality, accuracy, and content of Customer Data. We will not use your
          data for marketing or resale purposes.
        </p>
      </div>

      {/* ... (sections 7–15 would follow the same pattern) */}

      {/* Contact Section */}
      <div className="mt-12">
      <p className="mb-4 font-bold">Contact Us</p>
        <p>Support Team</p>
        <p>1978778 Ontario Inc. (Realty Space)</p>
        <p>
          Email:{" "}
          <a href="mailto:support@realtyspace.co" className="text-blue-600 underline">
            support@realtyspace.co
          </a>
        </p>
        <p>
          Website:{" "}
          <a
            href="https://www.realtyspace.co"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            www.realtyspace.co
          </a>
        </p>
      </div>
    </div>
                



                    </OffcanvasBody>
                </Offcanvas>
      </React.Fragment>
    )
  }
}

export default Footer;